<script>
import {Bar, mixins} from 'vue-chartjs'
const { reactiveProp } = mixins

let rectangleSet = false
let showTickIndex = 0

export default {
  extends: Bar,
  mixins: [reactiveProp],
  data () {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false,
          position: 'bottom'
        },
        tooltips: {
          callbacks: {
            label: (tooltipItems, data) => {
              let index = tooltipItems.datasetIndex
              return data.datasets[index].label + ': ' + tooltipItems.yLabel + '명'
            }
          }
        },
        scales: {
          xAxes: [{
            stacked: true,
            gridLines: {
              display: false
            }
          }],
          yAxes: [{
            stacked: true,
            ticks: {
              autoSkip: false,
              beginAtZero: true,
              min: 0,
              precision: 0,
              stepSize: 1,
              suggestedMax: 50,
              callback: function (value, index, values) {
                if(index === 0) {
                  // 배열의 첫번째일시 처리
                  showTickIndex = 0
                }
                let interval = Math.floor(values.length / 5)
                if(interval === 0) {
                  return value
                }
                if((index === showTickIndex || index === values.length - 1) && (value !== 1 && value !== 2 && value !== 3 && value !== 4)) {
                  // 첫값과 마지막값은 무조건 보여줌
                  // 0에 딱 붙는값들( value === 1, 2, 3, 4) 안나오게 처리
                  showTickIndex += interval
                  return value
                }
              }
            }
          }]
        },
        animation: {
          onComplete: function () {
            if (!rectangleSet) {
              var scale = window.devicePixelRatio
              var sourceCanvas = this.chart.canvas
              var copyWidth = this.scales['y-axis-0'].width - 10
              var copyHeight = this.scales['y-axis-0'].height + this.scales['y-axis-0'].top + 10

              var targetCtx = document.getElementById('axis-Test2').getContext('2d')

              targetCtx.scale(scale, scale)
              targetCtx.canvas.width = copyWidth * scale
              targetCtx.canvas.height = copyHeight * scale

              targetCtx.canvas.style.width = copyWidth + 'px'
              targetCtx.canvas.style.height = copyHeight + 'px'
              targetCtx.drawImage(sourceCanvas, 0, 0, copyWidth * scale, copyHeight * scale, -5, 0, copyWidth * scale, copyHeight * scale)

              var sourceCtx = sourceCanvas.getContext('2d')

              // Normalize coordinate system to use css pixels.

              sourceCtx.clearRect(0, 0, copyWidth * scale, copyHeight * scale)
            }
          },
          onProgress: function () {
            if (rectangleSet === true) {
              var copyWidth = this.scales['y-axis-0'].width
              var copyHeight = this.scales['y-axis-0'].height + this.scales['y-axis-0'].top + 10

              var sourceCtx = this.chart.canvas.getContext('2d')
              sourceCtx.clearRect(0, 0, copyWidth, copyHeight)
            }
          }
        }
      }
    }
  },
  mounted () {
    this.renderChart(this.chartData, this.options)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/board/elements/answeredBarChart.vue